<template>
  <div id="bidcontact" class="zl-form-group">
    <div class="zl-form-group-header">
      <div class="zl-form-group-title">
        <i class="title-decorate iconfont icon-decorate" />
        联系方式
      </div>
    </div>
    <div class="zl-form-group-form">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="采购单位" prop="purOfficeNo" label-width="70px">
            <!-- <el-input v-model="form.biddingNo" /> -->
            <el-select
              v-if="!isDisplay"
              v-model="form.purOfficeNo"
              filterable
              remote
              reserve-keyword
              placeholder="请搜索"
              :remote-method="remoteMethod"
              clearable
              :loading="selectLoding"
              @change="manageSelect"
            >
              <el-option
                v-for="item in unitList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span v-else class="mybidding-display"> {{ form.purOfficeNo }}{{ form.purOfficeName }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经办人" prop="operator" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.operator" />
            <span v-else class="mybidding-display"> {{ form.operator }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="phone" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.phone" />
            <span v-else class="mybidding-display"> {{ form.phone }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="联系邮箱" prop="email" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.email" />
            <span v-else class="mybidding-display"> {{ form.email }} </span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>

</template>
<script>
import http from '@/plugin/axios'
export default {
  props: {
    form: {
      type: Object,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDisplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectLoding: false,
      unitList: []
    }
  },
  created() {
    if (!this.isDisplay) {
      this.unitGet()
    }
  },
  methods: {
    remoteMethod(query) {
      this.unitGet(query)
    },
    manageSelect(item) {
      console.log(item)
    },
    async unitGet(query) {
      this.selectLoding = true
      const params = { usingFlag: '1', purchaseUnitPowerFlag: '2', keyword: query }
      const info = await http({
        url: '/purchaseUnit/getPurchaseUnitPage',
        baseURL: process.env.VUE_APP_BASE_API,
        data: {
          condition: {
            ...params
          },
          current: 1,
          size: 10
        }
      }) || {}
      setTimeout(() => {
        this.selectLoding = false
      }, 300)
      const unitList = info.records || []
      this.unitList = unitList.map((ele) => {
        return { label: `${ele.purchaseUnitNo}-${ele.purchaseUnitName}`, value: ele.purchaseUnitNo }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
@import './common.scss';

</style>
